import React from "react";

import { getFormattedDate } from "@services/dayjs";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import HubspotForm from "@sendmagic/prismic-nextjs/src/components/HubspotForm";

import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

// import "./styles/whitepaper-landing.scss";

// import "./styles/hubspot-form.scss";

const WhitepaperLandingPageSlice = ({ doc }) => {
  const {
    internal_link_id,
    heading,
    description,
    published_on,
    image,
    hubspot_form_id,
    typeform_link: { embed_url: typeformUrl, title: typeformTitle } = {},
    typeform_height,
  } = doc?.primary || {};

  return (
    <div className="whitepaper-landing-slice prismic-slice">
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container container-width container-2xl">
        <div className="row">
          <div className="col-md-6 whitepaper-landing-content-section">
            {checkContentPresence(heading) && (
              <div className="sns-h4 font-weight-bold whitepaper-landing-content-title same-size-title">
                {textResolver(heading)}
              </div>
            )}
            {checkContentPresence(description) && (
              <div className="mt-3 mt-md-4 sns-h5 whitepaper-landing-content-description">
                {textResolver(description)}
              </div>
            )}
            {checkContentPresence(published_on) && (
              <div className="mt-2 mt-md-4 whitepaper-landing-content-date">
                PUBLISHED ON {getFormattedDate(published_on)}
              </div>
            )}
            {image?.url && (
              <div className="mt-4 mt-md-5 whitepaper-landing-content-image-holder">
                <PrismicImgix
                  className="img-responsive img-responsive-height whitepaper-landing-content-image"
                  src={image?.url}
                  alt={image?.alt}
                  desktop="400px"
                  mobile="360px"
                  tablet="350px"
                  largeDisplay="800px"
                />
              </div>
            )}
          </div>

          <div className="col-md-6 whitepaper-landing-form-section">
            {hubspot_form_id && (
              <div className="whitepaper-landing-form-holder">
                <HubspotForm formId={hubspot_form_id} classes="hubspot-whitepaper-form" />
              </div>
            )}
            {typeformUrl && (
              <div className="whitepaper-landing-form-holder p-2">
                <iframe
                  src={typeformUrl}
                  loading="lazy"
                  frameBorder="0"
                  style={{ height: typeform_height, width: "100%" }}
                  title={typeformTitle}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhitepaperLandingPageSlice;
